import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';

const ANDROID_NAV_BUTTON_MIN_PX = 40;

@Component({
  selector: 'ml-root',
  imports: [IonApp, IonRouterOutlet],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  constructor() {
    void this.initNativeInsets();
  }

  private async initNativeInsets(): Promise<void> {
    this.syncNavButtonInset();
    if (!Capacitor.isNativePlatform()) return;

    try {
      await StatusBar.setStyle({ style: Style.Light });
      await StatusBar.setOverlaysWebView({ overlay: true });
      if (Capacitor.getPlatform() === 'android') {
        document.documentElement.style.setProperty('--ml-status-bar-fallback', '24px');
        const { height } = await StatusBar.getInfo();
        if (height > 0) {
          document.documentElement.style.setProperty('--ml-status-bar-fallback', `${height}px`);
        }
        window.addEventListener('resize', () => this.syncNavButtonInset());
      }
    } catch (error) {
      console.error('[AppComponent] Failed to initialize status bar', error);
    }
    this.syncNavButtonInset();
  }

  private syncNavButtonInset(): void {
    let inset = 0;
    if (Capacitor.getPlatform() === 'android') {
      const probe = document.createElement('div');
      probe.style.position = 'absolute';
      probe.style.visibility = 'hidden';
      probe.style.paddingBottom = 'env(safe-area-inset-bottom, 0px)';
      document.documentElement.appendChild(probe);
      inset = Number.parseFloat(getComputedStyle(probe).paddingBottom);
      probe.remove();
      if (!Number.isFinite(inset) || inset < ANDROID_NAV_BUTTON_MIN_PX) inset = 0;
    }
    document.documentElement.style.setProperty('--ml-nav-button-inset', `${inset}px`);
  }
}
